module.exports = __webpack_public_path__ + "static/media/ptz.f331174d.svg";